const form038C = {
  formId038C: "new-user-form038C",
  formField038C: {
    totalTaxTNDN: {
      name: "totalTaxTNDN",
      label: "[04] Tổng số thuế TNDN phải nộp được phân bố (đồng):",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tổng số thuế TNDN phải nộp được phân bố (đồng)",
    },
    totalExpense: {
      name: "totalExpense",
      label: "[05] Tổng doanh thu bán vé thực tế (đồng):",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tổng doanh thu bán vé thực tế (đồng)",
    },
  },
};

export default form038C;
